import Column from '@components/Column';
import Skeleton from '@components/Skeleton';
import Text from '@components/Text';
import colors from '@constants/colors';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import coinIcon from '../../assets/ic_coin.svg';
import loadingIcon from '../../assets/ic_prepaid_loading.svg';

function CardSkeleton() {
    const { t } = useTranslation('prepaidCard');

    return (
        <Column fullWidth aria-busy>
            <CardArea>
                <Card>
                    <LoadingIcon src={loadingIcon} alt='' />
                    <Text size='body-short' fontWeight='regular' color={colors.textSecondary} align='center'>
                        {t('loadingCard.message')}
                    </Text>
                </Card>
            </CardArea>
            <Detail fullWidth spacing={5} align='center'>
                <Column fullWidth align='center' spacing={1}>
                    <Skeleton width={140} height={22} />
                    <Text size='display' fontWeight='bold' color={colors.gray5} align='center'>
                        {t('loadingCard.balance')}
                    </Text>
                </Column>
                <ChargeButton type='button' disabled>
                    <Coin src={coinIcon} alt='' />
                    <Text size='body-short' fontWeight='bold' color={colors.gray5}>
                        {t('actions.charge')}
                    </Text>
                </ChargeButton>
            </Detail>
        </Column>
    );
}

const float = keyframes`
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-8px); }
`;

const CardArea = styled.div`
    padding: 16px 36px;
    width: 100%;
`;

const Card = styled.div`
    align-items: center;
    aspect-ratio: 3 / 2;
    background: var(--color-gray1);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    width: 100%;
`;

const LoadingIcon = styled.img`
    animation: ${float} 1.2s ease-in-out infinite;
    display: block;
    height: 76px;
    width: 72px;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

const Detail = styled(Column)`
    padding: 8px 16px 16px;
`;

const ChargeButton = styled.button`
    align-items: center;
    background: var(--color-white);
    border: 1px solid var(--color-gray2);
    border-radius: 16px;
    display: flex;
    gap: 8px;
    justify-content: center;
    min-height: 56px;
    padding: 16px 12px;
    width: 100%;

    &:disabled {
        opacity: 0.5;
    }
`;

const Coin = styled.img`
    height: 24px;
    object-fit: contain;
    width: 24px;
`;

export default CardSkeleton;
